import { render, staticRenderFns } from "./browser.vue?vue&type=template&id=7211f504&scoped=true&"
import script from "./browser.vue?vue&type=script&lang=js&"
export * from "./browser.vue?vue&type=script&lang=js&"
import style0 from "./browser.vue?vue&type=style&index=0&id=7211f504&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7211f504",
  null
  
)

export default component.exports